
import React, { Component } from 'react';
import { Form, Divider } from 'semantic-ui-react';
import { Common } from '../../common';
import Role from '../../enums/role';

class ContactForm extends Component {
  render() {
    // SSR-safe: guard localStorage
    const rawRoles = typeof window !== 'undefined' ? localStorage.getItem('roles') : null;
    const userRole = rawRoles != null ? Number(rawRoles) : null;

    const translations = Common.getTranslations?.() || {};
    const roleId = Common.getUserRole?.();
    const isAdmin = roleId === Role.labelCenter || roleId === Role.labelManager;

    return (
      <Form className="com-contact-container">
        <p>
          {isAdmin
            ? "If you're having an issue that could use the attention of a real person, please call us or send an email."
            : translations['LexHavingIssueCallUs'] ?? "If you're having an issue, please call us or send an email."}
        </p>

        <Divider hidden />

        <p className="info">
           {(roleId === 1 || roleId === 2 || roleId === 5) && (
            <span>CONTACT US</span>
          )}
          <br/>
          {(roleId === 1 || roleId === 2 || roleId === 5) && (
            <a
              href="https://markshub.ul.com/labelcenter-location"
              target="_blank"
              rel="noopener noreferrer"
            >
              CONTACT UL SOLUTIONS LABEL CENTERS
            </a>
          )}

          {(roleId === 3 || roleId === 4 || roleId === 6) && (
            <span>Please contact us at 1-877-854-3577, Ext. 2 or field@ul.com</span>
          )}
        </p>
      </Form>
    );
  }
}

export default ContactForm;
